<script setup>
import { onMounted } from 'vue';
import axios from "axios";
import Submissions from "./Components/Submissions/submission.vue";
import { useFVStore} from "./stores/formvibes";

const store = useFVStore();

onMounted( () => {
});
</script>

<template>
    <el-config-provider>
      <div>
        <Submissions :store="store" />
      </div>
  </el-config-provider>
</template>

